import { render, staticRenderFns } from "./AddFood.vue?vue&type=template&id=07e7a17e&scoped=true"
import script from "./AddFood.vue?vue&type=script&lang=js"
export * from "./AddFood.vue?vue&type=script&lang=js"
import style0 from "./AddFood.vue?vue&type=style&index=0&id=07e7a17e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e7a17e",
  null
  
)

export default component.exports